module.exports = __webpack_public_path__ + "img/check_confirm.ddc4da56.svg";